module.exports = __webpack_public_path__ + "assets/07aa2312527bc9b6990b275af272c74e.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/DASS/DASS04.mp3
 ** module id = 213
 ** module chunks = 0
 **/